import { useEffect } from 'react';

import { getPrepLessonsWithoutDetailsIds, getShouldLoadPrepLessonsDetails } from 'common.components/lesson/utils';
import { LoadPrepLessonsDetailsOptions } from 'store/prep-lessons/typings';

export const useLoadPrepLessonsDetails = (options: LoadPrepLessonsDetailsOptions) => {
    const {
        prepLessonsIds,
        prepLessonsDetails,
        courseId,
        prepLessonsDetailsLoadingStatus,
        loadPrepLessonsDetailsRequest,
    } = options;

    useEffect(() => {
        if (prepLessonsIds && prepLessonsIds.length && courseId) {
            const lessonWithoutDetailsIds = getPrepLessonsWithoutDetailsIds(prepLessonsIds, prepLessonsDetails);
            const shouldLoadPrepLessonsDetails = getShouldLoadPrepLessonsDetails(
                lessonWithoutDetailsIds.length,
                prepLessonsDetailsLoadingStatus
            );

            if (shouldLoadPrepLessonsDetails) {
                loadPrepLessonsDetailsRequest({
                    courseId,
                    lessonsIds: lessonWithoutDetailsIds,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prepLessonsIds, courseId]);
};
